import React from 'react';
import {
  useAppKit,
  useAppKitAccount,
  useDisconnect,
} from '@reown/appkit/react';
import { getShortAddressStr } from './../utils';

const WalletConnect = ({ className = '', variant = '' }, props) => {
  const { open } = useAppKit();
  const { isConnected, address } = useAppKitAccount();
  const { disconnect } = useDisconnect();

  const handleWalletConnect = () => {
    open();
  };

  const setProvider = (type) => {
    window.localStorage.setItem('provider', type);
  };

  return (
    <>
      {isConnected ? (
        <button
          onClick={() => {
            disconnect();
            setProvider('');
          }}
          type='button'
          className={`${
            className ? className : 'btn mb-0 me-0 me-md-3'
          } btn-info`}
        >
          {`Disconnect ${getShortAddressStr(address)}`}
        </button>
      ) : (
        <button
          onClick={handleWalletConnect}
          type='button'
          className={` ${variant ? variant : 'bg-gradient-primary'} ${
            className
              ? className
              : 'btn bg-gradient-primary mb-0 me-0 me-md-3 px-3 px-md-4'
          }`}
        >
          Wallet Connect
        </button>
      )}
    </>
  );
};

export default WalletConnect;
